module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_ashinagasan-d05c8f6faa8ddab22c7925662196eae9.png";